import React from "react";

export default function CornerTitle({ data }) {
  return (
    <div
      className="corner-title"
      style={{
        position: "absolute",
        top: window.navigator.platform.includes("Win") ? "11px" : "8px",
        right: data.corner_title.second_half ? "0" : "40px",
        height: "90px",
        width: "100%",
        // backgroundColor: "rgb(210,35,78)",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      <img
        alt=""
        src={data.corner_title.first_letter_src}
        style={{
          margin: data.corner_title.first_letter_margin,
          height: data.corner_title.first_letter_height,
        }}
      />
      <h3
        style={{
          textAlign: "center",
          marginBottom: window.navigator.platform.includes("Win")
            ? "12px"
            : "6px",
          marginLeft: "2px",
          color: "#c20839",
          fontFamily: "LG_Smart_Bold",
          fontSize: "2.5rem",
        }}
      >
        {data.corner_title.title}
      </h3>
      {data.corner_title.second_half ? (
        <>
          <div
            style={{
              backgroundColor: "grey",
              width: "1.2px",
              height: "40px",
              margin: "0 15px",
            }}
          ></div>
          <h3
            style={{
              color: data.corner_title.second_half_color
                ? data.corner_title.second_half_color
                : "rgb(255,255,255)",
              fontFamily: "LG_Smart_Bold",
              margin: "0 40px 0 0",
              fontSize: "2.8rem",
            }}
          >
            {data.corner_title.second_half}
          </h3>
        </>
      ) : null}
    </div>
  );
}
